type ICopiedIcon = {
  color?: string;
};
export const CopiedIcon = (props: ICopiedIcon) => {
  const { color = '#222530' } = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 16C5.34315 16 4 14.6569 4 13V7C4 5.34315 5.34315 4 7 4H13C14.6569 4 16 5.34315 16 7M17 20H10C8.34315 20 7 18.6569 7 17L7 10C7 8.34315 8.34315 7 10 7L17 7C18.6569 7 20 8.34315 20 10L20 17C20 18.6569 18.6569 20 17 20Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.672 16.3376C12.5032 16.3376 12.343 16.2702 12.2249 16.1521L10.1835 14.1106C9.93884 13.866 9.93884 13.4611 10.1835 13.2164C10.4281 12.9718 10.833 12.9718 11.0777 13.2164L12.672 14.8108L16.2993 11.1835C16.5439 10.9388 16.9488 10.9388 17.1935 11.1835C17.4381 11.4281 17.4381 11.833 17.1935 12.0776L13.119 16.1521C13.0009 16.2702 12.8407 16.3376 12.672 16.3376Z"
        fill={color}
      />
    </svg>
  );
};
